import React from 'react';
import moment from 'moment';
import { withtRatification, withDocumentsReview } from '../constants';

const useGetStepsFromInvoiceObject = (invoice) => {
  const statusDatetime = (status) => {
    const processingHistoryStatus = invoice.historystatusSet.find(
      (invoiceHistoryStatus) => invoiceHistoryStatus.status === status,
    );
    return processingHistoryStatus
      ? moment(processingHistoryStatus.createdAt).format('DD/MM/YYYY HH:mm').replace('.', '')
      : '';
  };

  const invoiceActualStatus = invoice.lastHistoryStatus?.status || invoice.status;
  const transferCondition = invoice?.offer?.transferCondition;

  const statusSteps = [
    {
      id: `${invoice.id}-PROCESSING-step`,
      status: 'PROCESSING',
      startedDatetime: statusDatetime('Processing'),
      extraComponent: <></>,
      actualState: false,
      finished: false,
    },

    {
      id: `${invoice.id}-PENDINGTRANSFER-step`,
      status: 'PENDINGTRANSFER',
      startedDatetime: statusDatetime('PendingTransfer'),
      extraComponent: <></>,
      actualState: false,
      finished: false,
    },
    {
      id: `${invoice.id}-TRANSFERED-step`,
      status: 'TRANSFERED',
      startedDatetime: statusDatetime('Transfered'),
      actualState: false,
      finished: false,
      extraComponent: <></>,
    },
    {
      id: `${invoice.id}-FINISHED-step`,
      status: 'FINISHED',
      startedDatetime: statusDatetime('Finished'),
      actualState: false,
      finished: statusDatetime('Finished'),
      extraComponent: <></>,
    },
  ];

  if (transferCondition) {
    if (withtRatification.includes(transferCondition)) {
      const ratificationStep = {
        id: `${invoice.id}-PENDINGRATIFICATION-step`,
        status: 'PENDINGRATIFICATION',
        startedDatetime: statusDatetime('PendingRatification'),
        extraComponent: <></>,
        actualState: false,
        finished: false,
      };
      statusSteps.splice(1, 0, ratificationStep);
    }

    if (withDocumentsReview.includes(transferCondition)) {
      const documentReviewStep = {
        id: `${invoice.id}-PENDINGDOCUMENTSREVIEW-step`,
        status: 'PENDINGDOCUMENTSREVIEW',
        startedDatetime: statusDatetime('PendingDocumentsReview'),
        extraComponent: <></>,
        actualState: false,
        finished: false,
      };
      statusSteps.splice(1, 0, documentReviewStep);
    }
  }

  const actualStatusIndex = statusSteps.findIndex(
    (step) => step.status === invoiceActualStatus.toUpperCase(),
  );

  if (actualStatusIndex !== -1) {
    statusSteps[actualStatusIndex].actualState = true;
    for (let i = 0; i < actualStatusIndex; i += 1) {
      statusSteps[i].finished = true;
    }
  }
  return statusSteps;
};

export default useGetStepsFromInvoiceObject;
